import React from 'react';
import { useTranslation } from 'react-i18next';
import ProfileImage from '../profileImage';

const CreatePostForm = ({ 
  newPost, 
  setNewPost, 
  onSubmit, 
  isLoading, 
  currentUser 
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-white rounded-2xl shadow-lg p-6">
      <form onSubmit={onSubmit}>
        <div className="flex items-start gap-4 mb-4">
          <ProfileImage
            image={currentUser?.profilePicture}
            alt={currentUser?.userName}
            className="w-12 h-12 rounded-full object-cover ring-2 ring-blue-100"
          />
          <div className="flex-1">
            <textarea
              className="w-full p-4 border-2 border-gray-100 rounded-xl mb-2 
                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
                placeholder:text-gray-400 min-h-[120px] transition-all resize-none"
              placeholder={t("feed.whatsOnYourMind")}
              value={newPost.content}
              onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
              disabled={isLoading}
            />
            
            {/* Preview Image */}
            {newPost.image && (
              <div className="relative mb-4 rounded-lg overflow-hidden">
                <img
                  src={URL.createObjectURL(newPost.image)}
                  alt="Preview"
                  className="max-h-[300px] w-full object-cover rounded-lg"
                />
                <button
                  type="button"
                  onClick={() => setNewPost({ ...newPost, image: null })}
                  className="absolute top-2 right-2 bg-black bg-opacity-50 text-white p-1.5 
                    rounded-full hover:bg-opacity-70 transition-all"
                  disabled={isLoading}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            )}

            <div className="flex items-center justify-between">
              {/* File Input Wrapper */}
              <div className="relative">
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setNewPost({ ...newPost, image: e.target.files[0] })}
                  className="hidden"
                  id="image-upload"
                  disabled={isLoading}
                />
                <label
                  htmlFor="image-upload"
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg border-2 border-blue-500 cursor-pointer transition-all ${
                    isLoading 
                      ? 'opacity-50 cursor-not-allowed' 
                      : 'text-blue-500 hover:bg-blue-500 hover:text-white'
                  }`}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" 
                    />
                  </svg>
                  <span>{t("feed.sharePhoto")}</span>
                </label>
              </div>

              <button
                type="submit"
                disabled={!newPost.content.trim() || isLoading}
                className="px-6 py-2.5 bg-blue-500 text-white rounded-lg 
                  hover:bg-blue-600 disabled:bg-gray-300
                  disabled:cursor-not-allowed transition-all
                  flex items-center gap-2 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 disabled:hover:transform-none"
              >
                {isLoading ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                    <span>{t("common.posting")}</span>
                  </>
                ) : (
                  <>
                    <span>{t("feed.post")}</span>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                        d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" 
                      />
                    </svg>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreatePostForm; 